import { DateTime } from "luxon";
import type { SingleDateRangeValue } from "../DateRangeInput";

interface GetEndMaximumParams {
  tempStart: SingleDateRangeValue;
  endInputPropMax?: DateTime;
  globalMax?: DateTime;
  maxRangeInDays?: number;
}

function getEndMaximum({
  tempStart,
  endInputPropMax,
  globalMax,
  maxRangeInDays
}: GetEndMaximumParams): DateTime | undefined {
  const rangeImpliedMax =
    tempStart && maxRangeInDays
      ? tempStart.plus({ days: maxRangeInDays })
      : undefined;
  const endMaxCandidates = [endInputPropMax, globalMax, rangeImpliedMax].filter(
    (d): d is DateTime => d !== undefined && d !== null
  );
  return DateTime.min(...endMaxCandidates);
}

export { getEndMaximum };
